import { render, staticRenderFns } from "./checkUpResultOpinionUpload.vue?vue&type=template&id=2382aab2"
import script from "./checkUpResultOpinionUpload.vue?vue&type=script&lang=js"
export * from "./checkUpResultOpinionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2382aab2')) {
      api.createRecord('2382aab2', component.options)
    } else {
      api.reload('2382aab2', component.options)
    }
    module.hot.accept("./checkUpResultOpinionUpload.vue?vue&type=template&id=2382aab2", function () {
      api.rerender('2382aab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpResultOpinionUpload.vue"
export default component.exports